import { render, staticRenderFns } from "./product-status.vue?vue&type=template&id=3b14d96e&"
import script from "./product-status.vue?vue&type=script&lang=js&"
export * from "./product-status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/sites/www/new.crt.ru/html/current_version/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b14d96e')) {
      api.createRecord('3b14d96e', component.options)
    } else {
      api.reload('3b14d96e', component.options)
    }
    module.hot.accept("./product-status.vue?vue&type=template&id=3b14d96e&", function () {
      api.rerender('3b14d96e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/components/product-status/product-status.vue"
export default component.exports